import filterMoviesByTimeRangeAndCinema from "./filterMoviesByTimeRangeAndCinema"
import { getFromWeekCinemaEndDate, getFromWeekCinemaStartDate } from '../getDateFromWeek'
import moment from "moment"


const filterMoviesByWeekAndCinemas = (order, items, performances, weekObj, cinemaIds = false, dateSettings) => {
    let weekPeriodeStartDate
    let weekPeriodeEndDate
    let previewMode 

    if(weekObj) {
        weekPeriodeStartDate = getFromWeekCinemaStartDate(weekObj.isoWeek, weekObj.year)
        weekPeriodeEndDate = getFromWeekCinemaEndDate(weekObj.isoWeek, weekObj.year)
    } else if(dateSettings) {
        const {startDate, endDate} = dateSettings
        weekPeriodeStartDate = moment(new Date(startDate))
        weekPeriodeEndDate = moment(new Date(endDate))
    } else if(!weekObj && !dateSettings) {
        weekPeriodeStartDate = moment(new Date())
        weekPeriodeEndDate = null
        previewMode = true
    }

    return filterMoviesByTimeRangeAndCinema(order, items, performances, weekPeriodeStartDate, weekPeriodeEndDate, cinemaIds, previewMode)
}

export default filterMoviesByWeekAndCinemas